const MAX_EPOCH_SECONDS = 1e10;

export const parseDate = (rawDate) => {
  if (
    typeof rawDate === "number" ||
    (typeof rawDate === "string" && /^\d+$/.test(rawDate))
  ) {
    const timestamp =
      typeof rawDate === "number" ? rawDate : parseInt(rawDate, 10);
    if (timestamp < MAX_EPOCH_SECONDS) {
      return new Date(timestamp * 1000);
    } else {
      return new Date(timestamp);
    }
  } else if (typeof rawDate === "string") {
    if (/^\d{4}-\d{2}-\d{2}$/.test(rawDate)) {
      const [year, month, day] = rawDate.split('-').map(Number);
      return new Date(year, month - 1, day);
    }
    return new Date(rawDate);
  } else if (rawDate instanceof Date) {
    return rawDate;
  }
  throw new Error("Unsupported date format");
};

export const DATE_FORMATS = {
    DD_MMMc_YYYY: "DD_MMMc_YYYY",
}

export const formatDate = (date, format) => {
    date = parseDate(date);
    switch (format) {
        case DATE_FORMATS.DD_MMMc_YYYY:
            const day = date.getDate();
            const month = date.toLocaleString('default', { month: 'short' });
            const year = date.getFullYear();
            return `${day} ${month}, ${year}`;
        default:
            return date.toLocaleString();
    }
}
